import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { appConfig } from '@/services/config'
import { isNative } from '@/utils/utils'

export const OpenWebAppBanner: FC = () => {
  const { t } = useTranslation('common')

  if (!isNative()) return null

  return (
    <div className="flex flex-row justify-between items-center bg-primary px-4 py-2">
      <span className="flex text-black text-xs xs:text-sm font-normal mr-2">
        <Trans>{t('wallet.nativeAppBanner.useWebApp')}</Trans>
      </span>
      <a
        href={appConfig.origin}
        className="min-w-[30%] text-xxs xs:text-xs text-black font-semibold px-2 py-1 rounded-full border border-black text-center"
      >
        {t('wallet.nativeAppBanner.openWebApp')}
      </a>
    </div>
  )
}
